/**
 * @description: 寄存设置
 * @author: hwx
 * @update: lyr
 */
<template>
    <div class="dept-manage">
        <div class="dept-list" v-show="!showSet">
            <div class="row">
                <button type="button" class="btn bg-orange btn-flat bigbtn" @click="add_dept()">新增寄存设置</button>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="deptList"></table>
            </div>
        </div>
        <!-- 新增/修改 -->
        <div class="dept-set" v-show="showSet">
            <div class="page-tit">{{add_header}}</div>
            <p class="page-notice">注：没有设置寄存期限的商品类型默认是不可寄存</p>
            <div class="row">
                <label class="col-md-1 ctr-label-left">门店：</label>
                <div class="col-md-4 ct-col">
                    <select class="form-control" ref="shop"></select>
                </div>
            </div>
            <div class="row">
                <label class="ctr-label-left">寄存到期时间：</label>
                <div class="col-md-4">
                    <div class="table-responsive">
                        <table class="table table-bordered table-hover" data-pagination="true" ref="goodsList"></table>
                    </div>
                </div>
            </div>
            <div class="row">
                <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="rtnFun()">返回</button>
                <button type="button" class="btn btn-flat btn-middle btn-orange sub-margin" @click="save(addModify)">保存</button>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    export default {
        name: 'order-list',
        data() {
            return {
                showSet: false,
                addModify: '1',
                dtShop: [],
                add_header: '新增寄存设置',

                goodsData: [],
                deptId: '',
                deptLimit: '',
            }
        },
        mounted: function() {
            this.innitTable();
            this.getShop();
        },
        methods: {
            // 初始化寄存设置列表
            innitTable: function() {
                let _this = this;
                $(_this.$refs.deptList).bootstrapTable('destroy');
                $(_this.$refs.deptList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getDeptList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "门店",
                        width: "25%"
                    }, {
                        field: "goods_type_name",
                        title: "寄存商品类型",
                        width: "25%"
                    }, {
                        field: "deposit_limit",
                        title: "寄存期限",
                        width: "25%",
                        formatter: function(value, row, index) {
                            return value + '天';
                        }
                    }, {
                        title: "操作",
                        events: {
                            'click .modify': function(e, value, row) {
                                _this.addModify = '2';
                                _this.deptId = row.id;
                                _this.add_header = '修改寄存设置';
                                $(_this.$refs.shop).val(row.shop_id).trigger('change');
                                $(_this.$refs.shop).prop('disabled', true);
                                _this.goodsData = [{ goods_type: row.goods_type, goods_type_name: row.goods_type_name, deposit_limit: row.deposit_limit }];
                                _this.innitGoods();
                                _this.showSet = true;
                            },
                            'click .deposit_status': function(e, value, row, index) {
                                let statustxt = "";
                                if(row.status == 1) {
                                    statustxt = "确定禁用【" + row.goods_type_name + "】的寄存规则?"
                                } else {
                                    statustxt = "确定启用【" + row.goods_type_name + "】的寄存规则?"
                                }
                                layer.confirm(statustxt, {
                                    btn: ['确定', '取消'], //按钮
                                }, function() {
                                    _this.updateDepstatus(row.id);
                                    layer.closeAll();
                                });
                            },
                        },
                        formatter: function(value, row, index) {
                            let status = "启用";
                            if(row.status == 1) {
                                status = "禁用";
                            } else {
                                status = "启用";
                            }
                            return '<span class="text-blue modify">修改</span><span class="text-blue modify deposit_status">' + status + '</span>'
                        }
                    }]
                });
            },
            // 获取寄存设置列表
            getDeptList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Setting/getDepositSettingList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.count,
                                rows: data.response.result.data
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 启用禁用
            updateDepstatus: function(id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Setting/setDepositSettingStatus",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.msg(data.response.error_msg);
                            _this.innitTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 点击‘新增寄存设置’
            add_dept: function() {
                let _this = this;
                _this.addModify = '1';
                _this.add_header = '新增寄存设置';
                $(_this.$refs.shop).val('').trigger('change');
                $(_this.$refs.shop).prop('disabled', false);
                _this.innitGoods();
                _this.showSet = true;
            },
            // 初始化门店输入框
            getShop: function() {
                let _this = this;
                
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [];
                            $.each(data.response.result, function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            arr.shift();
                            $(_this.$refs.shop).select2({
                                data: arr,
                                minimumResultsForSearch: -1,
                                language: "zh-CN",
                                width: '100%'
                            }).on("select2:select",function(e) {
                                _this.innitGoods();
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 初始化商品类型
            innitGoods: function() {
                let _this = this;
                $(_this.$refs.goodsList).bootstrapTable('destroy');
                $(_this.$refs.goodsList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 20,
                    pageList: [],
                    pagination: false,
                    ajax: function(params) {
                        _this.setGoodsList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "goods_type_name",
                        title: "商品类型",
                        width: "30%"
                    }, {
                        field: "deposit_limit",
                        title: "寄存期限",
                        width: "70%",
                        events: {
                            'blur .deplimit': function(e, value, row, index) {
                                let num = $.trim($(this).val());
                                if($.trim($(this).val()) == '') {
                                    _this.goodsData[index].deposit_limit = '';
                                    $(this).val(value);
                                    return;
                                } else if(isNaN(num) || num.indexOf('.') != '-1') {
                                    layer.msg("请输入整数");
                                    $(this).val(value);
                                    return;
                                } else if(num < 1) {
                                    layer.msg("寄存期限不小于1");
                                    $(this).val(value);
                                    return;
                                }
                                _this.goodsData[index].deposit_limit = num;
                            }
                        },
                        formatter: function(value, row, index) {
                            return '<input type="text" placeholder="请输入整数" class="deplimit" value="'+ value +'" /> 天';
                        }
                    }]
                });
            },
            // 获取商品类型
            setGoodsList: function(params) {
                let _this = this,
                    pageNumber = 1;

                if(_this.addModify == '2') {
                    params.success({
                        total: 1,
                        rows: _this.goodsData
                    });
                    return;
                }
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": $(_this.$refs.shop).val()
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Setting/getGoodsTypeList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.goodsData = [];
                            $.each(data.response.result, function(k, v) {
                                _this.goodsData.push({ goods_type: v.id, goods_type_name: v.name, deposit_limit: '' });
                            });
                            params.success({
                                total: data.response.result.length,
                                rows: _this.goodsData
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 返回
            rtnFun: function() {
                this.showSet = false;
            },
            // 保存新增/修改的寄存设置
            save: function(addModify) {
                let _this = this;
                let datas;
                let url = 'setDepositSetting';
                if(addModify == '1') {
                    let goods_type_info = [];
                    for(let i = 0; i < _this.goodsData.length; i++) {
                        if(_this.goodsData[i].deposit_limit != '') {
                            goods_type_info.push(_this.goodsData[i]);
                        }
                    }
                    datas = {
                        "header": Vue.request_header,
                        "request": {
                            "param": {
                                "shop_id": $(_this.$refs.shop).val(),
                                "goods_type_info": goods_type_info
                            }
                        },
                        "comment": ""
                    };
                } else if(addModify == '2') {
                    url = 'editDepositSetting';
                    datas = {
                        "header": Vue.request_header,
                        "request": {
                            "param": {
                                "id": _this.deptId,
                                "deposit_limit": _this.goodsData[0].deposit_limit
                            }
                        },
                        "comment": ""
                    };
                }
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "Setting/" + url,
                    async: true,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            layer.msg(data["response"]["error_msg"]);
                            _this.innitTable();
                            _this.showSet = false;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
    .dept-manage {
        .dept-set {
            .page-notice {
                margin: 10px 0 41px;
                color: #FE3C3C;
            }
            .table-responsive {
                margin: 0 0 30px;
            }
        }
    }
    .deplimit {
        text-align: center;
    }
</style>